/* eslint no-undef: 0 */
/* eslint arrow-parens: 0 */
import React from 'react';
import { enquireScreen } from 'enquire-js';

import Banner0 from './Banner0/Banner0';
import ImageBanner from './ImageBanner/ImageBanner';
import Feature0 from './Product/Product';
import IndustrySolutions from './IndSolutionsPart/IndustrySolutions';
import Feature00DataSource from './Product/dataSource'
import Customer00DataSource from './customer/dataSource'

import './less/antMotionStyle.less';
import CustomerCase from "./customer/CustomerCase";
import { scrollToTop } from './../Utils/CommonFunc';
import IndSolutions from "./IndSolutions/IndSolutions";

let isMobile;
enquireScreen((b) => {
  isMobile = b;
});

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile
    };
  }
  componentWillMount() {
    sessionStorage.setItem('activeTab', '首页');
    scrollToTop(0);
  }

  componentDidMount() {
    // 适配手机屏幕;
    enquireScreen((b) => {
      this.setState({ isMobile: !!b });
    });
  }

  render() {
    {/*<Banner0*/}
    {/*    id="Banner0_0"*/}
    {/*    key="Banner0_0"*/}
    {/*    dataSource={Banner01DataSource}*/}
    {/*    isMobile={this.state.isMobile}*/}
    {/*/>,*/}
    const children = [
      <ImageBanner key="imgBanner" />,
      <Feature0
          id="Feature0_0"
          key="Feature0_0"
          dataSource={Feature00DataSource}
          isMobile={this.state.isMobile}
      />,
      <IndSolutions key="IndSolutions " />,
      <CustomerCase
        id="Customer0_0"
        key="Customer0_0"
        dataSource={Customer00DataSource}
        isMobile={this.state.isMobile}
      />
    ];
    return (
        <div
            className="templates-wrapper"
            style={{ minHeight: 1600 }}
            ref={(d) => {
              this.dom = d;
            }}
        >
          {/* 如果不是 dva 2.0 替换成 {children} start */}
          {children}
          {/* 如果不是 dva 2.0 替换成 {children} end */}
        </div>
    );
  }
}
